import { type ComponentType, isValidElement } from 'react';
import { ErrorBoundary } from '@libs/common-next';
import { type CompositionItem, type Config, config, type Model } from './config';
import type { RendererProps } from './types';
import { resolveLegacyEntry } from './utils';

// Nested rendering retains the outer build context.
export function Renderer({
  entries
}: RendererProps) {
  return entries.map((entry, index) => {
    // Fallback to legacy builder when no transform is provided
    if ('sys' in entry) {
      const component = resolveLegacyEntry(entry, (model, key) => <Renderer key={key} entries={[model]} />, index);
      return isValidElement(component) ? component : null;
    }
    const contentType = entry.contentType as string;
    const props = entry.props as Model['props'] & {
      items?: CompositionItem[];
    };
    const Component = config[contentType as keyof Config] as ComponentType<typeof props>;
    return <ErrorBoundary key={index} tags={{
      contentful: 'true'
    }}>
                <Component {...props}>
                    {contentType === 'container' ? <Renderer entries={props.items ?? []} /> : null}
                </Component>
            </ErrorBoundary>;
  });
}